// extracted by mini-css-extract-plugin
export default {"container":"styles_container__alAcV","image":"styles_image__nd3nY","hints":"styles_hints__kEdXq"};